import { browserHistory } from '@assertiva/assertiva-ui';

export default browserHistory;
